import { fontSizes } from "#app/theme/v1/fontSizes";
import { QuoteRequestLinesSimilarPartDto } from "#modules/similarPart/infra/searchQuoteRequestLineSimilarParts.api";
import { PartName } from "#modules/similarPart/view/PartName";
import { QuotedAt } from "#modules/similarPart/view/QuotedAt";
import { Stack } from "#shared/view/components/Stack";

export const ClusterCardHeader = ({
  quoteRequestLine,
}: {
  quoteRequestLine: QuoteRequestLinesSimilarPartDto;
}) => {
  return (
    <Stack gap={"0"}>
      <QuotedAt ta={"center"} fw={700} fz={fontSizes.small} quoteRequestLine={quoteRequestLine} />

      <PartName partName={quoteRequestLine.part.name} files={quoteRequestLine.part.files} />
    </Stack>
  );
};
